// Only those that require special treatment need to be here
export const ErrorCode = {
  DUPLICATE_NAME: 'error.duplicateName',
  NO_DATA_FOUND: 'error.noDataFound',
  INCOMPATIBLE_VERSION: 'error.incompatibleVersion',
  PIN_REQUIRED: 'error.pinRequired',
  INVALID_PIN: 'error.login.badPin',
};
